import React from "react";
import PropTypes from "prop-types";
import ChipInput from "material-ui-chip-input";
import FormFieldError from "components/form/form-field-error";
import FormHelperText from "@material-ui/core/FormHelperText";
import { Field } from "formik";
import { formikPropTypes } from "components/common";

const ValidatedChipInput = ({ field: { name, value, onChange, onBlur }, helperText, defaultValue, ...props }) => {
  const handleAddChip = chip => {
    if (!defaultValue.includes(chip)) {
      onChange([...defaultValue, chip]);
    }
  };

  const handleDeleteChip = (chip, index) => {
    onChange(defaultValue.filter(val => val !== chip));
  };

  return (
    <>
      <ChipInput value={defaultValue} onAdd={handleAddChip} onDelete={handleDeleteChip} fullWidth {...props} />
      <FormHelperText>{helperText}</FormHelperText>
      <FormFieldError name={name} />
    </>
  );
};

ValidatedChipInput.propTypes = {
  ...formikPropTypes,
  /**
   * Texto de ayuda (opcional)
   */
  helperText: PropTypes.string,
  /**
   * Etiqueta opcional para el campo
   */
  label: PropTypes.string,
  /**
   * Valor por defecto del campo
   */
  defaultValue: PropTypes.array,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

const FormChipInput = ({ name, onChange, value, onBlur, ...props }) => (
  <Field
    component={ValidatedChipInput}
    field={{
      name,
      onChange: onChange(name),
      value,
      onBlur,
    }}
    {...props}
  />
);

FormChipInput.propTypes = {
  /**
   * Texto de ayuda para el campo
   */
  helperText: PropTypes.string,
  /**
   * Etiqueta opcional para el campo
   */
  label: PropTypes.string,
  /**
   * Valor por defecto del campo
   */
  defaultValue: PropTypes.array,
  /**
   * Valor actual del componente
   */
  value: PropTypes.array,
  /**
   * Nombre del input
   */
  name: PropTypes.string,
  /**
   * Callback que se dispara con el cambio de foco
   */
  onBlur: PropTypes.func,
  /**
   * Función que se ejecuta al cambiar el valor del campo
   */
  onChange: PropTypes.func,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
};

export default FormChipInput;
